<template>
  <b-table
    :data="data"
    :loading="loading"
    paginated
    backend-pagination
    :total="total"
    :per-page="perPage"
    @page-change="onPageChange"
    aria-next-label="Próxima Página"
    aria-previous-label="Página Anterior"
    aria-page-label="Página"
    aria-current-label="Página Atual"
  >
    <template slot-scope="props">
      <b-table-column field="id" label="#" numeric>
        {{ props.row.id }}
      </b-table-column>

      <b-table-column field="CNPJ" label="CNPJ">
        {{ props.row.cnpj | VMask('##.###.###/####-##') }}
      </b-table-column>

      <b-table-column field="name" label="Nome">
        {{ props.row.name }}
      </b-table-column>

      <b-table-column field="email" label="E-mail">
        {{ props.row.email || '-' }}
      </b-table-column>

      <b-table-column label="Opções">
        <button
          @click="edit(props.row.id)"
          v-app-button.icon-only
          v-tooltip.bottom="'Editar'"
        >
          <b-icon size="is-small" icon="pencil"></b-icon>
        </button>
      </b-table-column>
    </template>

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="emoticon-sad" size="is-large"></b-icon>
          </p>
          <p>Nenhum registro encontrado.</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import NetworkService from '@/services/network.service';
import ToastMixin from '@/mixins/ToastifyMixin';

export default {
  name: 'network-table',
  mixins: [ToastMixin],
  data: () => {
    return {
      data: [],
      total: 0,
      loading: false,
      page: 1,
      perPage: 10,
    };
  },
  methods: {
    load() {
      this.loading = true;

      NetworkService.get({
        page: this.page,
        perPage: this.perPage,
      })
        .then((response) => {
          const { total, data } = response.data;

          this.total = total;
          this.data = data;
        })
        .catch(() => this.toastify('Erro ao carregar Redes.', 'error'))
        .finally(() => (this.loading = false));
    },
    edit(id) {
      this.$router.push(`${id}/edit`);
    },
    onClickDeleteNetwork(id) {
      this.$buefy.dialog.confirm({
        title: 'Excluindo Rede',
        message:
          'Tem certeza que deseja <b>excluir</b> esta rede? Essa ação não pode ser desfeita.',
        cancelText: 'Cancelar',
        confirmText: 'Excluir Rede',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteNetwork(id),
      });
    },
    deleteNetwork(id) {
      NetworkService.delete(id)
        .then(() => {
          this.toastify('Rede excluída com sucesso.');
          this.load();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao tentar excluir Rede.',
            'error'
          );
        });
    },
    onPageChange(page) {
      this.page = page;
      this.load();
    },
  },
  mounted() {
    this.load();
  },
};
</script>
